/** User-facing site brand when settings.display_name is unset. */
export const DEFAULT_SITE_DISPLAY_NAME = 'NitroMule';
